import { DetailFeatures } from '../../../../redux/constants.ts';
import { selectADUCostDisplay } from '../../../../redux/features/selectors/costSelectors/selectADUCost.ts';
import { selectAtticCostDisplay } from '../../../../redux/features/selectors/costSelectors/selectAtticCost.ts';
import { selectBarnCostDisplay } from '../../../../redux/features/selectors/costSelectors/selectBarnCost.ts';
import { selectBelowGradeBathsCostDisplay } from '../../../../redux/features/selectors/costSelectors/selectBelowGradeBathsCost.ts';
import { selectCarportCostDisplay } from '../../../../redux/features/selectors/costSelectors/selectCarportCost.ts';
import { selectDeckCostDisplay } from '../../../../redux/features/selectors/costSelectors/selectDeckCost.ts';
import { selectDetachedGarageCostDisplay } from '../../../../redux/features/selectors/costSelectors/selectDetachedGarageCost.ts';
import { selectFinishedBasementAreaCostDisplay } from '../../../../redux/features/selectors/costSelectors/selectFinishedBasementAreaCost.ts';
import { selectFireplaceCostDisplay } from '../../../../redux/features/selectors/costSelectors/selectFireplaceCost.ts';
import { selectGarageCostDisplay } from '../../../../redux/features/selectors/costSelectors/selectGarageCost.ts';
import { selectManualCostDisplay } from '../../../../redux/features/selectors/costSelectors/selectManualCost.ts';
import { selectPatioCostDisplay } from '../../../../redux/features/selectors/costSelectors/selectPatioCost.ts';
import { selectPoolCostDisplay } from '../../../../redux/features/selectors/costSelectors/selectPoolCost.ts';
import { selectPorchCostDisplay } from '../../../../redux/features/selectors/costSelectors/selectPorchCost.ts';
import { selectShedCostDisplay } from '../../../../redux/features/selectors/costSelectors/selectShedCost.ts';
import { selectSpaCostDisplay } from '../../../../redux/features/selectors/costSelectors/selectSpaCost.ts';
import { selectTotalBasementAreaCostDisplay } from '../../../../redux/features/selectors/costSelectors/selectTotalBasementAreaCost.ts';
import { selectWorkshopCostDisplay } from '../../../../redux/features/selectors/costSelectors/selectWorkshopCost.ts';
import { RootState } from '../../../../redux/types.ts';

type FeatureCostSelectors = {
  [feature in DetailFeatures]: (state: RootState, id: string) => string | undefined;
};

export const FEATURE_COST_SELECTORS: FeatureCostSelectors = {
  garage: selectGarageCostDisplay,
  detachedGarage: selectDetachedGarageCostDisplay,
  carport: selectCarportCostDisplay,
  totalBasement: selectTotalBasementAreaCostDisplay,
  finishedBasement: selectFinishedBasementAreaCostDisplay,
  belowGradeBath: selectBelowGradeBathsCostDisplay,
  attic: selectAtticCostDisplay,
  fireplace: selectFireplaceCostDisplay,
  shed: selectShedCostDisplay,
  workshop: selectWorkshopCostDisplay,
  barn: selectBarnCostDisplay,
  pool: selectPoolCostDisplay,
  spa: selectSpaCostDisplay,
  adu: selectADUCostDisplay,
  deck: selectDeckCostDisplay,
  patio: selectPatioCostDisplay,
  porch: selectPorchCostDisplay,
  manualCost: selectManualCostDisplay,
};
